import React from 'react'
import { Link } from 'gatsby'

export default function BrandLogo() {
    return (
        <Link to='/' className='d-block'>
            <img src='/svg/bfd-logo-white.svg' alt='' style={{ height: 40 }} />
        </Link>
    )
}